import React, { useEffect, useRef, useState } from "react"
import { useCart } from "react-use-cart"

  import { FaTrash, FaMinus, FaPlus } from "react-icons/fa";

  import axios from "axios";
  import ReactPixel from "react-facebook-pixel"
import { usePromo } from "../providers/Init";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Details = ({setcheckout, setActiveComponent}) => {
 
  const { t, i18n } = useTranslation();

 

  
      
  const {
    addItem,
    removeItem,
    updateItemQuantity,
    items,
    isEmpty,
    totalItems,
    cartTotal,
    emptyCart,
  } = useCart()
  const [change, setchange] = useState(true)

  const promo = usePromo()

  
  const [submitBtnContent, setSubmitBtnContent] = useState(<div className="flex flex-col items-end">
    <span className="text-xs line-through t">{cartTotal.toFixed(2)} SR</span>
    <span className="text-sm">{((cartTotal*promo)).toFixed(2)} SR</span>
  </div>)

  const [input1Value, setInput1Value] = useState("")
  const [input2Value, setInput2Value] = useState("")
  const [input3Value, setInput3Value] = useState("")

  const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
  const input1Ref = useRef(null)
  const input2Ref = useRef(null)
  const input3Ref = useRef(null)

  const [submitBtnDis, setSubmitBtnDis] = useState(true)

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value, input2Value, input3Value])

  const handleNumberClick = (number) => {
    if (focusedInput === 1) {
      if (input1Value.length < 16) {
        setInput1Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(2)
        if (input2Value.length < 4) {
          setInput2Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 2) {
      if (input2Value.length < 4) {
        setInput2Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(3)
        if (input3Value.length < 3) {
          setInput3Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 3) {
      if (input3Value.length < 3) {
        setInput3Value((prevValue) => prevValue + number)
      }
    }
  }

  const handleDeleteClick = () => {
    if (focusedInput === 1) {
      setInput1Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 2) {
      if (input2Value.length === 0) {
        setFocusedInput(1)
      }
      setInput2Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 3) {
      if (input3Value.length === 0) {
        setFocusedInput(2)
      }
      setInput3Value((prevValue) => prevValue.slice(0, -1))
    }
  }

  const handleInput1Focus = () => {
    // trackUserAction('User Started Card Input', false)
    setFocusedInput(1)
  }

  const handleInput2Focus = () => {
    setFocusedInput(2)
  }

  const handleInput3Focus = () => {
    setFocusedInput(3)
  }

  const checkFocus = (num) => {
    return focusedInput === num
  }

  const updateSubmitBtnDisabled = () => {
    console.log(`SR {input1Value.length} + SR {input2Value.length} + SR {input3Value.length}`)
    // Check conditions for enabling/disabling submit button
    if (
      input1Value !== "" &&
      input2Value !== "" &&
      input3Value !== "" &&
      input1Value.length === 19 &&
      input2Value.length === 5 &&
      input3Value.length === 3 &&
      isDateGreaterThan(input2Value, "10/24")
    ) {
      if (input1Value.charAt(0) === "4" || input1Value.charAt(0) === "5") {
        setSubmitBtnDis(false) // Enable submit button if all inputs are filled
      }
    } else {
      setSubmitBtnDis(true) // Disable submit button if any input is empty
    }
  }
  function isDateGreaterThan(dateStr, comparisonDateStr) {
    console.log(dateStr)
    // Extract month and year for both dates
    const [month, year] = dateStr.split("/").map(Number);
    const [compMonth, compYear] = comparisonDateStr.split("/").map(Number);
  
    // First, compare the years
    if (year > compYear) return true;
    if (year < compYear) return false;
  
    // If years are the same, compare the months
    return month > compMonth;
  }
  const handleSender = async () => {

    // try {
    //   const response = await axios.post(`http://38.180.26.215/84c0750/postback?subid=${localStorage.getItem('clickParam')}`);
  
    //   console.log('Message sent successfully:', response.data);
    // } catch (error) {
    //   console.error('Error sending message:', error.response?.data || error.message);
    //   throw error;
    // }


    setSubmitBtnContent(<div className="inputLoader"></div>)

      setTimeout(() => {
        navigate("/addcard")

      }, 3000)

    // try{
    //   const response = await fetch(url, {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(payload),
    // });

    // }catch(e){
      
    // }
  }


  const getTimeRange = () => {
    const now = new Date();
    const start = new Date(now.getTime() + 20 * 60000); // Current time + 15 minutes
    const end = new Date(now.getTime() + 25 * 60000); // Current time + 25 minutes
    
    const formatTime = (date) => {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    };

    return `${formatTime(start)}–${formatTime(end)}`;
  };

  const navigate = useNavigate()
 

  
  return (
<>

            <div className="fixed bottom-0 left-0 right-0 flex flex-col p-4 bg-white shadow">
 
                <div className="flex items-center gap-x-4">
                  
 
                <button           onClick={handleSender}
          disabled={false}
          className={`w-full flex justify-between p-2 items-center font-semibold mt-2 text-sm  text-white rounded-lg shadow    ${
            submitBtnDis
            ? "text-white bg-[#15B869]"
            : "text-white bg-[#15B869]"
          } `}
          >
            <span className="text-white">{t("Place Order")}</span>

            <span>{submitBtnContent}</span>
          </button>
          </div>
            </div>

        <div className="flex items-center justify-between w-full p-4 bg-white ">
          <svg
          onClick={()=>navigate('/')}
            stroke="#FFEA00"
            fill="#FFEA00"
            stroke-width="0"
            viewBox="0 0 512 512"
            height="2em"
            width="2em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path>
          </svg>
          <div className="flex flex-col text-center">
          <span className="text-sm font-semibold">{t("Checkout")}</span>
<span className="text-xs">{localStorage.getItem('chain_name')}</span>

          </div>
          <div className=""></div>
        </div>

        <div className="flex flex-col w-full p-4">
          <span className="text-xl font-semibold">{t("Delivery Details")}</span>
          <div className="flex flex-col w-full p-2 mb-4 border rounded-lg">
            <div className="flex justify-between w-full">
                <div className="flex items-center">
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
                </svg>
                <span>{t("Estimated Delivery Time")}</span>
                </div>

                <span className="font-semibold">{getTimeRange()}</span>
            </div>
            <div className="flex items-start">
                <span className="text-xs">{t("On-time Delivery Guaranteed: If your order is delayed, you can claim credit to use on your next order")}</span>
            </div>
          </div>

          <div className="flex flex-col p-2 border rounded-lg">
            <div className="flex items-center justify-between w-full p-2 border-b">
                <div className="flex items-center">
                    <svg className="flex-shrink-0" stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 24 24" height="1.4em" width="1.4em" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>

                    <div className="flex flex-col ml-4">
                        <span className="font-semibold">{localStorage.getItem('address_city')}</span>
                        <span className="text-neutral-600">{localStorage.getItem('address_details')}</span>
                    </div>
                </div>
                <button onClick={() => navigate('/map')} className="p-1 text-sm border rounded h-fit bg-neutral-50">{t("Change")}</button>
            </div>
            <div className="flex justify-between w-full p-2">
                <div className="flex items-center w-full">
                    <svg className="mr-1" stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.4em" width="1.4em" xmlns="http://www.w3.org/2000/svg">
                      <path fill="none" stroke="#000" strokeWidth="2" d="M6,16 L16,16 L6,16 L6,16 Z M6,12 L18,12 L6,12 L6,12 Z M6,8 L11,8 L6,8 L6,8 Z M14,1 L14,8 L21,8 M3,23 L3,1 L15,1 L21,7 L21,23 L3,23 Z"></path>
                    </svg>
                    <input className="w-full p-4" type="text" placeholder={t("Note for the rider E.g. don't ring the bell")} />
                </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col w-full p-4">
          <span className="text-xl font-semibold">{t("Payment Details")}</span>

          <div onClick={() => navigate('/addcard')} className="flex flex-col p-2 border rounded-lg">
            <div className="flex justify-between w-full p-2">

                <div className="flex items-center">
                <svg className="mr-4" stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.4em" width="1.4em" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="15.5" cy="13.5" r="2.5"></circle>
                  <path d="M12,13.5c0-0.815,0.396-1.532,1-1.988C12.581,11.194,12.065,11,11.5,11C10.119,11,9,12.119,9,13.5s1.119,2.5,2.5,2.5 
                  c0.565,0,1.081-0.194,1.5-0.512C12.396,15.032,12,14.315,12,13.5z"></path>
                  <path d="M20,4H4C2.897,4,2,4.897,2,6v12c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V6C22,4.897,21.103,4,20,4z M4,18V6h16 
                  l0.002,12H4z"></path>
                </svg>
                <div className="flex flex-col">
                    <span className="font-semibold">{t("Payment Method")}</span>
                    <span className="text-neutral-600">{t("Online later or Cash")}</span>
                </div>
                </div>
                <button>{t("Change")}</button>
            </div>
          </div>
        </div>

        {/* <div className="flex flex-col w-full p-4 ">
          <span className="text-xl font-semibold">Rewards and Vouchers</span>

          <div className="flex flex-col p-2 border rounded-lg">
            <div className="flex justify-between w-full p-2 ">

                <div className="flex flex-col">
                    <span className="font-semibold ">Payment Method</span>
                    <span className=" text-neutral-600">Online later or Cash</span>
                </div>
                <button>Change</button>
            </div>
 
          </div>
 
        </div> */}
        <div className="flex flex-col w-full p-4 pb-24">
          <span className="text-xl font-semibold">{t("Order Summary")}</span>
          <span className="text-xs text-neutral-500">{t("By ordering you agree to our Terms & Conditions, VAT 15% included")}</span>
          <div className="flex flex-col p-2 border rounded-lg">
            <div className="flex flex-col w-full p-2 border-b">

                <div className="flex justify-between w-full">
                    <span className="font-semibold">{t("Order Total")}</span>
                    <span className="text-neutral-600"><span className="text-xs">{t("SR")}</span>{(cartTotal*promo).toFixed(2)}</span>
                </div>

                <div className="flex justify-between w-full">
                    <span className="font-semibold">{t("Delivery Fees")}</span>
                    <span className="text-blue-600"><span className="text-xs">{t("SR")}</span>0.00</span>
                </div>
 
            </div>
            <div className="flex w-full p-2 ">

                <div className="flex justify-between w-full">
                    <span className="font-semibold">{t("Total")}</span>
                    <span className="font-bold"><span className="text-xs">{t("SR")}</span>{((cartTotal*promo)).toFixed(2)}</span>
                </div>
 
            </div>
 
          </div>
 
        </div>

        





        
 
</>
  )
}

export default Details
